<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/quality/inspection/standard/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jianyanbiaozhunmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <el-select v-model="yt.conditions.types" multiple clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds">
            </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'"
							:ids.sync="yt.conditions.materialIds">
						</yi_cross_select>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t("chongzhi") }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="
      yt.showEditDialog('xinzeng', null, 'w1');
    setDefaultValue();
    " type="primary" v-if="utils.checkPower('web_quality_management_inspection_standard_create')">
          {{ $t("xinzeng") }}
        </el-button>
        <el-button size="mini" v-if="utils.checkPower('web_quality_management_inspection_standard_batchImport')" @click="show = !show" plain>
          {{ $t('daoru') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #jianyanleixing="scope">
        <span v-if="scope.row.type == 1">{{ $t("shoujian") }}</span>
        <span v-if="scope.row.type == 2">{{ $t("choujian") }}</span>
        <span v-if="scope.row.type == 3">{{ $t("mojian") }}</span>
        <span v-if="scope.row.type == 4">{{ $t("chengpinjian") }}</span>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fuzhi', scope.row); setCopyDefaultValue();" v-if="utils.checkPower('web_quality_inspection_standard_copy')">
              {{ $t("fuzhi") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mingxi', scope.row, '80%')" v-if="utils.checkPower('web_quality_management_inspection_standard_details_page')">
              {{ $t("mingxi") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)" v-if="utils.checkPower('web_quality_management_inspection_standard_update')">
              {{ $t("bianji") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" v-if="utils.checkPower('web_quality_management_inspection_standard_delete')" @click="yt.remove(scope.row, '/web/quality/inspection/standard/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('jianyanbiaozhunmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.type" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/standard/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '物料检验标准-新增物料检验标准' } }">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('jianyanbiaozhunmingcheng')" required>
            <el-input disabled v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jianyanleixing')" required>
            <el-select disabled v-model="yt.editObj.type" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select disabled :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/standard/update')" type="primary">{{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 复制 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('jianyanbiaozhunmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jianyanleixing')" required>
            <el-select v-model="yt.editObj.type" @change="getMethods" clearable>
              <el-option :label="$t('shoujian')" :value="1"></el-option>
              <el-option :label="$t('choujian')" :value="2"></el-option>
              <el-option :label="$t('mojian')" :value="3"></el-option>
              <el-option :label="$t('chengpinjian')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshi')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
              <el-option v-for="(item, index) in inspectionMethods" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')" required>
            <yi_cross_select :selectTitle="'code,name'" :max="1" :component="'web_base_matter_list'" :ids.sync="yt.editObj.materialId"> </yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled" @change="$forceUpdate()">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/quality/inspection/standard/copy')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '物料检验标准-复制物料检验标准' } }">{{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'mingxi'">
        <div class="dialog-scroller">
          <details_item_index :details="yt.editObj"></details_item_index>
        </div>
      </template>
    </el-dialog>
    <!-- 配置 -->
    <el-dialog :show-close="true" :title="$t('peizhi')" :visible.sync="showSpotCheckDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
        <el-form-item :label="$t('chaochanleixing')" required="required">
          <el-select v-model="yt.editObj.overProductionType">
            <el-option :label="$t('bili')" :value="0"></el-option>
            <el-option :label="$t('shuliang')" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('chaochanzhi')" required="required">
          <el-input v-model="yt.editObj.overProductionValue"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="saveTime()">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="saveTime()" type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 导入excel -->
    <import-excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import details_item_index from "@@/pages/web/quality_management/inspection_standard/details_item_index";
import importExcel from './imaterial_standard_import_excel'
export default {
  name: "web_quality_management_inspection_standard_list",
  components: {
    details_item_index,
    importExcel
  },
  data() {
    return {
      inspectionMethods: [],
      show: false,
      list: [],
      alertTypeList: [],
      showSpotCheckDialog: false,
      columns: [
        {
          label: "jianyanbiaozhunmingcheng",
          prop: "name",
          // type: 'slot',
        },
        {
          label: "jianyanleixing",
          // prop: 'type',
          type: "slot",
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
        },
        {
          label: "jianyanbiaozhunbanben",
          prop: "version",
        },
        {
          label: "shifouqiyong",
          prop: "enabled",
          type: "bool",
          iln18: ["shi", "fou"],
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  watch: {
    "yt.editObj.action": {
      handler(n) {
        console.log("jjjjjj", n);
        if ((n = "xinzeng")) {
          this.getWarning();
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = "/web/system/auth/user/listByIds";
      this.yt.SELECT_RESULT_KEY = "data";
      this.yt.SELECT_ID = "id";
      this.yt.SELECT_TITLE = "nickname";
      this.yt.get(1);
      this.getRolesList();
      this.utils.event_hub.$on('STANDARDS_LIST_REFRESH', () => {
        this.yt.get(1);
      })
    }, 300);
  },
  filters: {
    getRoleText(value) {
      return value
        .map((item) => {
          return item.name;
        })
        .join(",");
    },
  },
  methods: {
    setCopyDefaultValue() {
      this.$set(this.yt.editObj, 'inspectionMethodId', null)
      this.yt.editObj.type = null;
      this.inspectionMethods = [];
    },
    async getMethods() {
      this.yt.editObj.inspectionMethodId = null;
      this.inspectionMethods = [];
      if (this.yt.editObj.type == undefined || this.yt.editObj.type == null) {
        this.$message.warning(this.$t('qingxuanzejianyanleixing'));
        return;
      }
      try {
        const res = await this.http.get('/web/quality/inspection/method/list', {
          params: {
            inspectionType: this.yt.editObj.type
          }
        });
        if (res.data && res.data.length > 0) {
          this.inspectionMethods = res.data;
        } else {
          this.$message.warning(this.$t('gaijianyanleixingbucunzaijianyanfangshi'));
        }
      } catch (err) {
        this.$message.error(this.$t(err));
      }
    },

    showTime() {
      this.showSpotCheckDialog = true;
    },
    saveTime() {
      this.showSpotCheckDialog = false;
    },
    async getRolesList() {
      let response = await this.http.get("/web/customer/auth/role/page", {
        params: {
          pageNum: 1,
          pageSize: 10,
        },
      });
      this.rolesList = response.data.rows;
    },
    setDefaultValue() {
      this.yt.editObj.enabled = true;
    },
    getWarning(editObj) {
      this.http
        .get("/web/warning/type/page", {
          params: {
            pageNum: 1,
            pageSize: 1000,
          },
        })
        .then((res) => {
          this.alertTypeList = res.data.rows;
          console.log("alertTypeList", this.alertTypeList);
          let typeName = "";
          for (let i = 0; i < this.alertTypeList.length; i++) {
            this.alertTypeList[i].typeName = this.alertTypeList[i]["type"] + "/" + this.alertTypeList[i]["name"];
          }
        })
        .catch((msg) => {
          // this.utils.errorMessage(msg);
        });
    },
  },
};
</script>
